'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".ClaimsList-module_claimsList__3OmrE{box-sizing:border-box;display:flex;flex-direction:column;gap:.75rem;list-style:none;margin:0;padding:0;width:100%}";
var styles = {"claimsList":"ClaimsList-module_claimsList__3OmrE"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
